import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useConferenceStore = defineStore("parent/conference", {
  state: () => {
    return {
      selected: null as any,
      selectedDay: null as any,
      conferences: [] as any[],
      conferenceDays: [] as any[],
      error: null as any,
      loading: false
    };
  },
  getters: {
    getById: (state) => {
      return (conferenceId) =>
        state.conferences.find((conference) => conference.conference_id === conferenceId);
    }
  },
  actions: {
    async fetchConferences() {
      this.loading = true;
      try {
        const conferences = await FetchService.fetchData("/conferences", "get");
        
        if (Array.isArray(conferences)) {
          conferences.forEach((conference) => {
            if (conference && Array.isArray(conference.conference_days)) {
              const conference_days = conference.conference_days.sort((a, b) => {
                return a.start < b.start ? -1 : 1;
              });
              conference.conference_days = conference_days;
            } else {
              conference.conference_days = [];
            }
          });
          
          this.conferences = conferences;
        } else {
          this.conferences = [];
        }
      } catch (error) {
        console.error("Error fetching conferences:", error);
        this.error = error;
        this.conferences = [];
      } finally {
        this.loading = false;
      }
    },
    async initializeStore(id) {
      this.loading = true;
      try {
        const conferences = await FetchService.fetchData("/conferences", "get");
        
        if (Array.isArray(conferences)) {
          conferences.forEach((conference) => {
            if (conference && Array.isArray(conference.conference_days)) {
              const conference_days = conference.conference_days.sort((a, b) => {
                return a.start < b.start ? -1 : 1;
              });
              conference.conference_days = conference_days;
            } else {
              conference.conference_days = [];
            }
          });
          
          this.conferences = conferences;
          
          this.selected = this.conferences.find((conference) => {
            return conference.conference_id == id;
          }) || null;
          
          if (this.selected && this.selected.conference_days && this.selected.conference_days.length > 0) {
            this.selectedDay = this.selected.conference_days[0];
          } else {
            this.selectedDay = null;
          }
        } else {
          this.conferences = [];
          this.selected = null;
          this.selectedDay = null;
        }
      } catch (error) {
        console.error("Error initializing conference store:", error);
        this.error = error;
        this.conferences = [];
        this.selected = null;
        this.selectedDay = null;
      } finally {
        this.loading = false;
      }
    }
  }
});
